import React from 'react';

import { Wrapper, Button, StartIcon, EndIcon } from './styled/TrainerCallButtonStyled';
import Spinner from '../../common/Spinner';
import colors from '../../../utils/colors';
interface LocalizationLike {
    getText: (key: string) => string;
}

interface CallButtonProps {
    isCallStarted: boolean;
    sendManualCallEvent: (start: boolean) => void;
    setDisabled: () => void;
    isManualCallButtonEnabled: boolean;
    localization: LocalizationLike;
}

function CallButton({ isCallStarted, sendManualCallEvent, setDisabled, isManualCallButtonEnabled, localization }: CallButtonProps) {
    const getButtonLabel = () => {
        return localization.getText(isCallStarted ? 'call_buttons.end' : 'call_buttons.start');
    };
    const getButtonIcon = () => {
        return isCallStarted ? <EndIcon /> : <StartIcon />;
    };
    const onButtonClick = () => {
        if (!isCallStarted) {
            setDisabled();
        }
        sendManualCallEvent(!isCallStarted);
    };

    if (!isManualCallButtonEnabled) {
        return (
            <Wrapper data-testid="trainer-call-button-loading">
                <div style={{ width: 32 }}>
                    <Spinner $size="30px" $runnerColor={colors.blue.palatinate_blue} $backgroundColor={colors.gray.athens} />
                </div>
            </Wrapper>
        );
    }

    return (
        <Wrapper data-testid="trainer-call-button">
            <Button
                data-testid={isCallStarted ? 'trainer-call-button-end' : 'trainer-call-button-start'}
                $isCallStarted={isCallStarted}
                onClick={onButtonClick}>
                {getButtonIcon()}
                <span>{getButtonLabel()}</span>
            </Button>
        </Wrapper>
    );
}

export default CallButton;
